// Abonnement aux notifications push (Web Push / VAPID).
// Appelé après connexion : enregistre le service worker, demande l'autorisation,
// récupère la clé publique VAPID du serveur, s'abonne et envoie l'abonnement.

import { isLoggedIn, getCsrfToken } from './lib/authState';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function initPush() {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) return;

    // Correctif B7 : plus de jeton lisible cote client. On s'appuie sur le
    // drapeau de session non sensible ; l'appel /api/push/subscribe plus bas
    // est de toute facon authentifie par cookie et renverra 401 si besoin.
    if (!isLoggedIn()) return; // seulement pour les utilisateurs connectés

    const reg = await navigator.serviceWorker.register('/service-worker.js');
    await navigator.serviceWorker.ready;

    if (Notification.permission === 'denied') return;
    if (Notification.permission === 'default') {
      const perm = await Notification.requestPermission();
      if (perm !== 'granted') return;
    }

    // Clé publique VAPID
    const keyRes = await fetch(`${API_URL}/api/push/public-key`);
    const { public_key: publicKey } = await keyRes.json();
    if (!publicKey) return;

    // Abonnement existant ou nouveau
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }

    // Envoi au serveur
    // Correctif B7 : `credentials: 'include'` joint le cookie httpOnly.
    await fetch(`${API_URL}/api/push/subscribe`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...(getCsrfToken() ? { 'X-CSRF-Token': getCsrfToken() } : {}) },
      body: JSON.stringify({ subscription: sub }),
    });
  } catch (e) {
    // silencieux : le push est un bonus, il ne doit jamais bloquer l'app
  }
}
